export default "__VITE_ASSET__l1kF3BaK__"